<ng-container  *ngIf="isBrowser && dealsArea.length > 0">
      <app-da
        *ngFor="let dealArea of dealsArea"
        [adTransition]="adLocationSettings.transition"
        [adId]="dealArea.deal.trackingSlugName"
        [partnerId]="dealArea.deal.brand.trackingSlugName"
        [areaId]="dealArea.trackingSlugName"
        [adYOffset]="adYOffset"
        [closeTrackingPixel]="adLocationSettings.closeTrackingPixel" [noMoreTrackingPixel]="adLocationSettings.noMoreTrackingPixel">
        <a [href]="dealArea?.tinyUrl" target="_blank">
          <app-picture-source
            [imgSrc]="dealArea.deal.planMedia?.contentUrl"
            [alt]="dealArea.deal.description"
            [presets]="imgPreset | imgPreset"
            [useLazyLoad]="false"
            [width]="301" [height]="251"
            bucket="kozikaza-affiliate-files"
          ></app-picture-source>
        </a>
        <img *ngIf="isProd" [src]="dealArea?.pixelUrl" style="display: none">
      </app-da>
</ng-container>
